module.exports = __webpack_public_path__ + "static/media/to-label.577ff360.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/to-label.svg
// module id = 655
// module chunks = 0